export const QA_NAME_VIEW_REQUEST_BUTTON = 'viewRequest'
